import { render, staticRenderFns } from "./userpay.vue?vue&type=template&id=951a6e64&scoped=true&"
import script from "./userpay.vue?vue&type=script&lang=js&"
export * from "./userpay.vue?vue&type=script&lang=js&"
import style0 from "./userpay.vue?vue&type=style&index=0&id=951a6e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951a6e64",
  null
  
)

export default component.exports